/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';

import * as actions from '../action';
import * as c from '../constant';

function BusinessLineRequirementsTagging({
  getRequirementList, 
  requirementList,
  getPermitTypeList, 
  permitTypeList,
  updateBusinessLineRequirements,
  getBusinessLinesList,
  businessLinesList,
  getBusinessLine,
  businessLine,
  getReportAccess,
}) {
  const [businessLineId, setBusinessLineId] = useState(null);
  const [requirementListFormat, setRequirementListFormat] = useState([]);
  const [permitTypeListFormat, setPermitTypeListFormat] = useState([]);
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const permissions = getJson('permissions');
  const authProfile = getJson('profile') || {};

  const updateData = () => {
    getBusinessLinesList()
    getRequirementList({ display_all: 1 });
    getPermitTypeList();
  };

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const formatFormData = () => {
    if (!_.isEmpty(permitTypeList && businessLine)) {
      const list = permitTypeList.map(item => {
      // check if businessLine has data for this item.id
        const detailedRequirements = businessLine ? businessLine.data[+item.id] : 0;
        return {
          id: item.id,
          type: _.get(item, 'attributes.name', ''),
          requirement_list: detailedRequirements 
            ? detailedRequirements.map(requirement => ({
                requirement_id: requirement.requirement_id,
                is_required: requirement.is_required,
                id: requirement.id,
                application_status_id: requirement.application_status_id,
                business_line_id: requirement.business_line_id,
              }))
            : []  // if no data in businessLine
        };
      });
      setPermitTypeListFormat(list);
      setFormData(list);
    }
  };

  const handleLineDropDownChange = key => e => {
    const args = { 
      business_line_id: e ? +e.value : 0
    };
    getBusinessLine(args, () => {
      formatFormData()
    })
    setBusinessLineId(e.value)
  };

  const toggleIsRequired = (array, requirementId) =>
    array.map(item =>
      item.requirement_id === requirementId ? { ...item, is_required: !item.is_required ? 1 : 0 } : item
    );

  const handleSetMode = (num) => {
    setMode(num);
  };

  const handleToggle = (type, permitId, reqId) => () => {
    handleSetMode(1);
    const item = formData.find(x => (+x.id === +permitId)); // GET TARGET ROW

    let status;
    let payload;

    if (type === "requirement_id") {
      status = item?.requirement_list.filter(x => (+x.requirement_id === +reqId));
      if (_.isEmpty(status)) {
        payload = _.concat(_.get(item, 'requirement_list', []), [{ requirement_id: +reqId, is_required: 0 }]);
      } else {
        payload = item?.requirement_list.filter(x => (+x.requirement_id !== +reqId));
      }
    }

    if (type === "is_required") {
      status =  item?.requirement_list.filter(x => (+x.requirement_id === +reqId && x.is_required === 1));
      payload = toggleIsRequired(item?.requirement_list, +reqId)
    }

    const newItem = { // REFORMAT TARGET WITH NEW VALUE
      ...item,
      requirement_list: payload,
    };

    const reducedFormData = formData.filter(x => (+x.id !== +newItem.id)); // REMOVE TARGET FROM FORMDATA
    const newFormData = _.concat(reducedFormData, newItem); // REBIULD FORMDATA
    setFormData(newFormData);
  };

  const renderCheckbox = (type, permitId, reqId) => {
    const item = formData.find(x => (+x.id === +permitId));
    const status = item?.requirement_list?.filter(
      x => +x.requirement_id === +reqId && (type !== "is_required" || x.is_required === 1)
    ) || [];

    return (
      <button type="button" className="btn-blank" onClick={handleToggle(type, permitId, reqId)}>
        {_.isEmpty(status)
          ? (<i className="far fa-square icon-check-box" />)
          : (<i className="fas fa-check-square icon-box" />)}
      </button>
    );
  };

  const handleSubmit = () => {
    handleSetMode(0);
    const data = formData.map(item => ({ 
      business_line_id: businessLineId,
      application_status_id: item.id, 
      requirements: item.requirement_list 
    }));

    // const filteredData = args.filter(item => item.requirements.length > 0);

    const payload = {
      data
    }

    updateBusinessLineRequirements(payload)
  };

  const handleCancel = () => {
    setFormData(permitTypeListFormat);
    handleSetMode(0);
  };

  const handleDownload = (e) => {
    e.preventDefault();
    getReportAccess(
      {
        path: '/api/v1/bpls/administrator/report/business_line_requirements/generate_pdf',
        query: {
          email: _.get(authProfile, 'email'),
          output: 'D',
        },
      },
      (response) => {
        window.location.href = `${response?.res?.res?.url || ''}`;
      }
    );
  };

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [permitTypeList, businessLine]);

  useEffect(() => {
    if (!_.isEmpty(requirementList)) {
      const list = requirementList.map(x => ({
        requirement_id: _.get(x, 'id', ''),
        requirement_name: _.get(x, 'attributes.name'),
      }));
      setRequirementListFormat(list);
    }
  }, [requirementList]);

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6">
              <h3>Requirements Tagging</h3>
            </div>
            <div className="col-6 d-flex justify-content-end align-items-center">
              {mode === 1 ? (
                <React.Fragment>
                  {Acl(permissions, ['BPLS BUSINESS LINE REQUIREMENT TAGGING']) && (
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 mr-1"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary btn-round font-weight-bold px-4 mr-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : ''
              }
              {Acl(permissions, ['DOWNLOAD BPLS REQUIREMENTS REPORT']) && (
                <a
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4"
                  href="#/"
                  onClick={handleDownload}
                >
                  <i className="fas fa-print" /> Generate PDF
                </a>
              )}
            </div>
          </div>
          {/* TABLE */}
          <div className="form-group mt-2" style={{width: "30%"}}>
            <label className="form-label">
              Business Line:
            </label>
            <Select
              options={selectBusinessLineId}
              placeholder="Select Business Line"
              onChange={handleLineDropDownChange('business_line_id')}
            />
          </div>
          {businessLineId !== null && (
            <div className="table-responsive mt-2">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    {!_.isEmpty(permitTypeListFormat)
                      ? (
                        <React.Fragment>
                          <th scope="col" className="px-1">
                            <div style={{ width: '300px' }}>
                              Requirement Types
                            </div>
                          </th>
                          {permitTypeListFormat.map((item, index) => (
                            <React.Fragment key={item.id}>
                              <th 
                                scope="col" 
                                key={item.id}
                                className={`py-3 ${
                                  index !== permitTypeListFormat.length - 1
                                    ? 'border-right'
                                    : ''
                                }`}
                              >
                                <div className="row" style={{ width: '300px' }}>
                                  <div
                                    className="col-6 text-center"
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {item.type || ''}
                                  </div>
                                  <div
                                    className="col-6 text-center"
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    IS REQUIRED
                                  </div>
                                </div>
                              </th>
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ) : (
                        <th scope="col">Requirement Types</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {!_.isEmpty(requirementListFormat) ? (
                    <React.Fragment>
                      {requirementListFormat.map(item => (
                        <tr className="top-border" key={item.requirement_id}>
                          <td className="font-weight-bold py-3">
                            {item.requirement_name}
                          </td>
                          {permitTypeListFormat.map((x, index) => (
                            <td
                              key={x.id}
                              className={`py-3 ${
                                index !== permitTypeListFormat.length - 1
                                  ? 'border-right'
                                  : ''
                              }`}
                            >
                              <div className="row">
                                <div className="col-6 text-center">
                                  {renderCheckbox(
                                    'requirement_id',
                                    x.id,
                                    item.requirement_id
                                  )}
                                </div>
                                <div className="col-6 text-center">
                                  {renderCheckbox(
                                    'is_required',
                                    x.id,
                                    item.requirement_id
                                  )}
                                </div>
                              </div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  ) : (
                    <tr />
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

BusinessLineRequirementsTagging.propTypes = {
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,

  getPermitTypeList: PropTypes.instanceOf(Function).isRequired,
  permitTypeList: PropTypes.instanceOf(Array).isRequired,

  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,

  updateBusinessLineRequirements: PropTypes.instanceOf(Function).isRequired,
  getBusinessLine: PropTypes.instanceOf(Function).isRequired,
  businessLine: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  permitTypeList: _.get(api, `${c.GET_PERMIT_TYPE_LIST}.list`) || [],
  requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
  businessLine: _.get(api, `${c.GET_BUSINESS_LINE}.res`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(BusinessLineRequirementsTagging);
